import { Breakpoints } from './settings';

( function BlogSingle() {

    // Get outa here if this isn't a blog page.
    if( ! $WP_Body.hasClass( 'single-post' ) ) {
        return;
    }

    setupSharing();
    $(window).on( 'resize', setupSharing );


    /**
     * Setup social sharing.
     */
    function setupSharing() {

        const $container = $( document.querySelector( '[data-social-sharing]') );
        const $et_container = $( document.querySelector( '.et_social_mobile' ) );
        const icon_selector = '.et_social_icons_container';
        const $icons = $( document.querySelector( icon_selector ) );

        // Only run on medium up
        if( ! Breakpoints.mdUp() ) {
            return;
        }

        customizeIcons();


        /**
         * Customize the display of social icons.
         */
        function customizeIcons() {

            $icons.detach();
            $container.append( $icons );
        }

        /**
         * Reset social icons to original layout.
        */
        function resetIcons() {

            // const $icons = $( document.querySelector( icon_selector ) );
            // console.log( $icons.parent() );
            // if( ! $custom_icons.legth ) {
            //     return;
            // }

            //console.log( 'lets go' );

   

        }
    }


} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/blog-single.js